import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { usePageTogglers } from "@Client/@Composables/application-standalone/page-helpers/usePageToggler";
import { computed, defineComponent, ref, toRefs, watch } from "@vue/composition-api";
import PageTogglerLayout from "../layout/page-toggler-layout.vue";
import { useScrollTopOnLoad } from "@Shared/@Composables/generic/useScrollTopOnLoad";
import PageStepLayout from "@Client/@Modules/application-standalone/components/layout/page-step-layout.vue";
import GoalPropertySection from "./summary/goal-property-section.vue";
import ApplicantsSection from "./summary/applicants-section.vue";
import AssetsSection from "./summary/assets-section.vue";
import LiabilitiesSection from "./summary/liabilities-section.vue";
import IdentificationsSection from "./summary/identifications-section.vue";
import OtherPropertiesSection from "./summary/other-properties-section.vue";
import IncomeHistorySection from "./summary/income-history-section.vue";
import AdditionalInformationSection from "./summary/additional-information-section.vue";
import DisclaimersSection from "./summary/disclaimers-section.vue";
import { useSummaryHelpers } from "@Client/@Composables/application-standalone/pages/summary/useSummaryHelpers";
import { APPLICATION_STEPS } from "@Client/@Utils/enums";
import { useApplicationVisibilityState } from "@Client/@Composables/application-standalone/machine/useApplicationVisibilityState";
import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
import * as AccountGetters from "@Client/@Modules/main/store/account/account-getters";
import { useAccountStoreGetters } from "@Client/@Modules/main/store/account/account-helpers";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "SummaryPage",
  components: {
    PageTogglerLayout,
    PageStepLayout,
    GoalPropertySection,
    ApplicantsSection,
    AssetsSection,
    LiabilitiesSection,
    OtherPropertiesSection,
    IncomeHistorySection,
    AdditionalInformationSection,
    DisclaimersSection,
    SectionTitle,
    IdentificationsSection
  },
  props: {
    invalidSteps: {
      type: Array,
      default: () => []
    }
  },
  setup(props, {
    emit
  }) {
    useScrollTopOnLoad();
    const {
      invalidSteps
    } = toRefs(props);
    const {
      t
    } = useI18n();
    const {
      handlePageTogglerNavigation,
      showInformationPage,
      togglerMetadata,
      handleNavigateNext,
      handleNavigateBack
    } = usePageTogglers();
    const isGoalsValid = ref(false);
    const isApplicantsValid = ref(false);
    const isIncomesValid = ref(false);
    const isAssetsValid = ref(false);
    const isLiabilitiesValid = ref(false);
    const isIdentificationsValid = ref(false);
    const isOtherPropertiesValid = ref(false);
    const isConsentsValid = ref(false);
    const {
      applicationHasLiabilities,
      applicationHasIdentifications,
      showDisclaimersSection,
      userCanSubmit,
      getCoApplicantStatus
    } = useSummaryHelpers();
    const {
      visibilityState
    } = useApplicationVisibilityState();
    const {
      EMAIL_VERIFIED
    } = useAccountStoreGetters([AccountGetters.EMAIL_VERIFIED]);
    const {
      IS_FILL_OUT,
      APPLICATION_IS_LOCKED
    } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.IS_FILL_OUT, ApplicationStandaloneGetters.APPLICATION_IS_LOCKED]);
    const visiblePages = computed(() => {
      var _context;
      return _mapInstanceProperty(_context = visibilityState.value).call(_context, ({
        name
      }) => name);
    });
    const isPageVisible = page => {
      var _context2;
      return _includesInstanceProperty(_context2 = visiblePages.value).call(_context2, page);
    };
    const canSubmit = computed(() => {
      return (invalidSteps.value.length === 0 || invalidSteps.value.length === 1 && invalidSteps.value[0] === APPLICATION_STEPS.INCOME_HISTORY) && (!showDisclaimersSection.value || isConsentsValid.value);
    });
    const applicationMessage = computed(() => {
      let path = "applicationSubmittedCongrat";
      if (APPLICATION_IS_LOCKED.value) path = "applicationLockedMessage";
      return t(`application-standalone.pages.submit.${path}`);
    });
    const hasMissingInformation = page => {
      var _context3;
      return page !== APPLICATION_STEPS.INCOME_HISTORY && _includesInstanceProperty(_context3 = invalidSteps.value).call(_context3, page);
    };
    watch(canSubmit, newValue => {
      emit("disable-save", !newValue);
    }, {
      immediate: true
    });
    return {
      showInformationPage,
      handlePageTogglerNavigation,
      togglerMetadata,
      applicationHasLiabilities,
      applicationHasIdentifications,
      showDisclaimersSection,
      handleNavigateNext,
      handleNavigateBack,
      APPLICATION_STEPS,
      isPageVisible,
      userCanSubmit,
      getCoApplicantStatus,
      EMAIL_VERIFIED,
      isGoalsValid,
      isApplicantsValid,
      isIncomesValid,
      isAssetsValid,
      isLiabilitiesValid,
      isIdentificationsValid,
      isOtherPropertiesValid,
      isConsentsValid,
      canSubmit,
      IS_FILL_OUT,
      hasMissingInformation,
      APPLICATION_IS_LOCKED,
      applicationMessage
    };
  }
});